import { AppEntity, ContactPersonId, ContactTypeEnum, StationId } from '@app/icare/db/schema/common'
import { ClinicId } from '@app/icare/entities/clinic/schema/Clinic'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'
import { PrescriberStatusSchema } from './common/PatientPrescriber'
import { PatientRelation } from './PatientRelation'

export const PatientClinicId = entityId('patientClinic')

export type PatientClinicIdType = typeof PatientClinicId.Type

export const PatientClinicRelationSchema = PatientRelation.extend({
  id: PatientClinicId.schema,
  toId: ClinicId.ref,
  prescriber: PrescriberStatusSchema.nullish(),
  comment: z.string().nullish(),
})

export type PatientClinicRelation = z.infer<typeof PatientClinicRelationSchema>

export const PatientClinicContactPersonId = entityId('patientClinicContactPerson')

export const PatientClinicContactPersonSchema = AppEntity.extend({
  id: PatientClinicContactPersonId.schema,
  ownerId: PatientClinicId.ref,
  contactPersonId: ContactPersonId.ref,
  contactType: z.enum(ContactTypeEnum.$.enum),
})

export type PatientClinicContactPerson = z.infer<typeof PatientClinicContactPersonSchema>
export const PatientClinicStationId = entityId('patientClinicStation')

export const PatientClinicStationSchema = AppEntity.extend({
  id: PatientClinicStationId.schema,
  ownerId: PatientClinicId.ref,
  stationId: StationId.ref,
  contactType: z.enum(ContactTypeEnum.$.enum),
})

export type PatientClinicStation = z.infer<typeof PatientClinicStationSchema>
